import { mapStrings } from "../../lib/frTypo";

/**
 * "Le ticket" reel — on-screen copy, FR only for now.
 *
 * Sources (landing, packages/landing/src/i18n/locales/fr.json):
 *   - end line  → steps.title.line2 "ton influence mérite d'être rémunérée"
 *   - end sub   → B2C cta.sub (faq.a1 free, faq.a3 no followers, /vs cash)
 *   - footnote  → B2C unpaid.footnote
 * The amounts are examples inside the live brands' rewards (5–30 € per
 * sale) and always sit next to the footnote. B2C house style: tutoiement,
 * no em dashes, no hype words.
 */
export const TICKET = mapStrings({
  hook: "Ce que tes recos t'ont rapporté cette année",
  kicker: "TICKET DE CAISSE",
  title: "Tes recos",
  /** What you recommended, to whom, and an example gain per sale. */
  items: [
    { what: "Sérum", who: "ta sœur", gain: 6 },
    { what: "Baskets", who: "ton cousin", gain: 8 },
    { what: "Bougie", who: "ta mère", gain: 5 },
    { what: "Sac", who: "ta collègue", gain: 6 },
    { what: "Pull", who: "ton coloc", gain: 9 },
    { what: "Crème", who: "ta pote", gain: 10 },
    { what: "Parfum", who: "ta cousine", gain: 10 },
    { what: "Gourde", who: "ton frère", gain: 5 },
    { what: "Thé", who: "ta grand-mère", gain: 5 },
    { what: "Café", who: "ton boss", gain: 6 },
  ],
  total: "TOTAL",
  stamp: "AVEC",
  note: "Exemple. Le montant dépend de la marque.",
  end: {
    line: "Ton influence mérite d'être rémunérée.",
    sub: "Gratuit. Sans abonnés. Du vrai cash.",
  },
});
